import {
  collection,
  doc,
  getDocFromServer,
  getDocs,
  limit,
  orderBy,
  query,
} from "firebase/firestore";
import { db } from "../shared/api/firebase/config";

export async function fetchClientDoc(appId, clientId) {
  const clientRef = doc(
    db,
    "artifacts",
    appId,
    "public",
    "data",
    "clients",
    clientId,
  );
  // FIX P19++: Usar getDocFromServer para garantir dados SEMPRE frescos do Firestore,
  // evitando cache obsoleto do IndexedDB local que impedia refletir alterações no CRM
  const snap = await getDocFromServer(clientRef);
  return snap.exists()
    ? { id: snap.id, ...snap.data() }
    : { id: clientId, name: "CLIENTE NÃO ENCONTRADO" };
}

export async function fetchClientsCache(appId) {
  const ref = collection(db, "artifacts", appId, "public", "data", "clients");
  const snap = await getDocs(query(ref, limit(600)));
  return snap.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));
}

export async function fetchWorkspacesCache(appId) {
  const ref = collection(
    db,
    "artifacts",
    appId,
    "public",
    "data",
    "autos_workspaces",
  );
  const snap = await getDocs(
    query(ref, orderBy("updatedAt", "desc"), limit(500)),
  );
  return snap.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));
}
